<template>
  <div>
    <Row justify="center" type="flex" style="background: #ffffff">
      <Col span="24">
        <img
          style="width: 100%"
          src="../../../static/img/solutions/smartsite/banner1.png"
          alt="#"
        />
      </Col>
      <Col span="24" class="ContactUs_2">
        <div class="box_tital">展厅案例</div>
        <div style="display: flex; justify-content: center">
          <div class="box">
            <div
              v-for="(item, index) in photoArr1"
              :key="index"
              class="box_content"
            >
              <div>
                <img style="height: 300px" :src="item.photoUrl" alt="" />
              </div>
              <div style="margin-top: 15px">
                <div class="box_name">{{ item.ref }}</div>
                <div
                  style="
                    width: 94px;
                    height: 0px;
                    border: 2px solid #1f58ff;
                    margin: 0 auto;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      photoArr1: [
        {
          photoUrl: "../../../static/img/case/erju.png",
          ref: "中建二局智慧化展厅",
        },
        {
          photoUrl: "../../../static/img/case/yiye.png",
          ref: "一冶项目",
        },
        {
          photoUrl: "../../../static/img/case/puyang.png",
          ref: "濮阳市民和中心",
        },
        {
          photoUrl: "../../../static/img/case/yiyuan1.png",
          ref: "中间五局洛阳肿瘤医院",
        },
        {
          photoUrl: "../../../static/img/case/shixun.png",
          ref: "郑州技术学院实训中心",
        },
        {
          photoUrl: "../../../static/img/case/xiaofangdadui.png",
          ref: "平顶山消防大队",
        },
        {
          photoUrl: "../../../static/img/case/xiaofangzhongdui.png",
          ref: "西街消防中队安全教育体验",
        },

        {
          photoUrl: "../../../static/img/case/sanju.png",
          ref: "中建三局智慧化展厅",
        },
        {
          photoUrl: "../../../static/img/case/aiqing1.png",
          ref: "保定爱情广场项目",
        },
        {
          photoUrl: "../../../static/img/case/huji.png",
          ref: "胡集镇消防安全体验馆",
        },
        {
          photoUrl: "../../../static/img/case/tiejian.png",
          ref: "中国铁建智慧化展厅",
        },
        {
          photoUrl: "../../../static/img/case/baju.png",
          ref: "中建八局智慧化展厅",
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.ContactUs_1 {
  height: 520px;
  background-color: #f7f8fa;
  display: flex;
  justify-content: center;
}

.ContactUs_2 {
  height: 1789px;
  background-image: url("../../../static/img/solutions/smartsite/one.png");
  background-size: 100% 100%;
}

.ContactUs_2 .box {
  width: 1442px;
  height: 1640px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.ContactUs_2 .box_tital {
  height: 61px;
  font-family: SourceHanSansCN;
  font-weight: 500;
  font-size: 42px;
  text-align: center;
  padding: 20px 0 80px 0;
}

.ContactUs_2 .box_content {
  width: 386px;
  height: 380px;
  background: #ffffff;
  margin: 10px;
}

.ContactUs_2 .box_name {
  height: 32px;
  font-family: OPPOSans;
  font-weight: 500;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/solutions/exhibitionHall.vue